import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import { GithubPicker } from 'react-color';
import BootstrapTable from 'react-bootstrap-table-next';
import Moment from 'moment';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import FileSaver from 'file-saver';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import SwitchButton from '../../../commons/SwitchButton';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';

import 'moment/locale/hu';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../UgyfelszolgalatTooltips';
import TimeFormatter from '../../../commons/TimeFormatter';
import QueryEmptyState from '../../../commons/queryempty';


// momentLocalizer(Moment);

class UgyfelszolgalatContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      currentId: undefined,
      torlesId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalDelete: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      xlsxButtonLoading: false,
      // FORM VALUES
      formHelyszinOptions: [],
      formEvhoOptions: [],
      formTipusOptions: [],
      formNev: '',
      formAzonosito: '',
      formEvho: '',
      formTipus: '',
      formHelyszin: '',
      formSzinkod: '',
      formAkadalymentesitett: false,
      formHasznalhato: true,
      withoutFilters: true,
      switchActiveButton: 1
    };

  }

  componentDidMount() {
    this.listBejelentes();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) this.listBejelentes();
    }
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  processJson = (json) => {
    if (json) {
      json.forEach((item) => {
        item.rogz = this.timezoneToDate(item.rogz);
        item.hatarido = this.timezoneToDate(item.hatarido);
        item.mod = this.timezoneToDate(item.mod);
      });
    }
  }

  listBejelentes = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      if (this.state.switchActiveButton === 2) {
        Services.listBejelentes({ all: true }, (err, res) => {
          if (!err) {
            this.processJson(res[0]);
            this.setState({
              tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
              baseJson: res[0],
            });
          } else {
            this.setState({
              tableStatus: 'NETW'
            });
          }
        });
      } else if (this.state.switchActiveButton === 3) {
        const data = {
          azonosito: this.emptyOrNull(this.state.formAzonosito),
          nev: this.emptyOrNull(this.state.formNev),
          id: this.emptyOrNull(this.state.formHelyszin),
          tipus: this.emptyOrNull(this.state.formTipus),
          evho: this.emptyOrNull(this.state.formEvho)
        };
        if (Object.values(data).every(x => x == null)) {
          this.setState({ tableStatus: 'QUERY' });
        } else {
          Services.listBejelentesFilter(data, (err, res) => {
            if (!err) {
              this.processJson(res[0]);
              this.setState({
                tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
                baseJson: res[0],
              });
            } else {
              this.setState({
                tableStatus: 'NETW'
              });
            }
          });
        }
      } else if (this.state.switchActiveButton === 1) {
        Services.listBejelentes(null, (err, res) => {
          if (!err) {
            this.processJson(res[0]);
            this.setState({
              tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
              baseJson: res[0],
            });
          } else {
            this.setState({
              tableStatus: 'NETW'
            });
          }
        });
      }
    });
  }

  getBejelentes = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.getBejelentes(id, (err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',

          formNev: this.nullToString(res[0].nev),
          formAzonosito: this.nullToString(res[0].azonosito),
          formSzinkod: this.nullToString(res[0].szin),
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleColorChange = (color) => {
    this.setState({ formSzinkod: color.hex.substr(1, 6) });
  }

  handleEditClick = (id) => {
    this.props.globals.route.navigate({
      pathname: process.env.PUBLIC_URL + '/admin/ugyfelszolgalat/modositas',
      search: '?id=' + id,
    });
  }

  handleModifyClick = (id) => {
    this.props.globals.route.navigate({
      pathname: process.env.PUBLIC_URL + '/admin/ugyfelszolgalat/szerkesztes',
      search: '?id=' + id,
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }

  deleteBejelentes = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteBejelentes(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listBejelentes();
        this.props.globals.addSuccess('Eset törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.props.globals.route.navigate({
      pathname: this.props.globals.public_url.concat('/admin/ugyfelszolgalat/felvitel')
    });
  }

  submitForm = () => {
    const {
      currentId,
      formNev,
      formAzonosito,
      formSzinkod,
      formAkadalymentesitett,
      formHasznalhato,
      formType
    } = this.state;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {};

      submitObj.azonosito = this.emptyOrNull(formAzonosito);
      submitObj.nev = this.emptyOrNull(formNev);
      submitObj.szin = this.emptyOrNull(formSzinkod);

      Services.addBejelentes(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Eset felvéve!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listBejelentes();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    } else if (formType === 'MOD') {
      let submitObj = {};

      submitObj.id = this.emptyOrNull(currentId);
      submitObj.azonosito = this.emptyOrNull(formAzonosito);
      submitObj.nev = this.emptyOrNull(formNev);
      submitObj.szin = this.emptyOrNull(formSzinkod);

      Services.editBejelentes(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Eset módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listBejelentes();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          {row.modosithato && this.props.globals.hasRole(['UGYFELSZOLGALAT_ESET'], true) && (
            <React.Fragment>
              <Button className="icon-settings table-action-icon" id={'action-view-' + cell + 'szerkesztes'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'szerkesztes'} delay={50}>
                {'Fejadatok szerkesztése'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          {this.props.globals.hasRoleSpec(['UGYFELSZOLGALAT_ESET_MOD']) && (
            <React.Fragment>
              <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleModifyClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                {'Módosítás'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

  tableBooleanFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-danger">Nem</span>;
  }

  styleSzinkod = (szinkod) => {
    return {
      textAlign: 'center',
      whiteSpace: 'pre-line',
      backgroundColor: '#' + szinkod,
      color: this.getCorrectTextColor('#' + szinkod)
    };
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új eset létrehozása';
      case 'MOD':
        return 'Eset módosítása';
      default:
        return '';
    }
  }

  telefonIconFormatter = (cell) => {
    let formattedData = [];
    if (Array.isArray(cell.split('\n'))) {
      cell.split('\n').forEach((row, idx) => {
        if (row !== '') {
          let string = row.substr(row.indexOf(' ') + 1);
          let atIndex = string.indexOf('@');
          // &#8203; -> zero-width space character, soft-wrap
          if (atIndex > -1) string = <span>{string.slice(0, atIndex)}&#8203;{string.slice(atIndex)}</span>;
          formattedData.push(
            <span key={idx.toString()}>
              <span>
                <i className={'fa fa-fw fa-' + row.substr(0, row.indexOf(' '))} aria-hidden="true" />
                {' '}
                {string}
              </span>
              <br />
            </span>
          );
        }
      });
    } else {
      return '-';
    }

    return formattedData;
  }

  dateToTimezone = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatIso(date);
  }

  timezoneToDate = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatDateTime(date);
  }

  azonositoFormatter = (cell) => {
    const azonosito = cell.toString();
    return (
      <span>
        <b>
          {azonosito.substring(0, azonosito.length - 1)}
        </b>
        {azonosito.substring(azonosito.length - 1)}
      </span>
    );
  }

  allapotFormatter = (cell, row) => {
    return (
      <span style={{
        color: this.getCorrectTextColor('#' + row.szin)
      }}
      >
        {cell}
      </span>
    );
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        formatter: this.azonositoFormatter,
        sort: true
      },
      {
        dataField: 'tipus',
        text: 'Típus',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'helyszin',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'rogz',
        text: 'Létrehozva',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        formatter: this.timezoneToDate,
        sort: true
      },
      {
        dataField: 'bejelento',
        text: 'Ügyfél',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
        },
        formatter: this.telefonIconFormatter,
        sort: true
      },
      {
        dataField: 'hatarido',
        text: 'Határidő lejár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: (cell, row, rowIndex, colIndex) => {
          return {
            wordBreak: 'break-all',
            whiteSpace: 'pre-line',
            color: row.lejart && 'red'
          };
        },
        formatter: this.timezoneToDate,
        sort: true
      },
      {
        dataField: 'mod',
        text: 'Utolsó módosítás',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        formatter: this.timezoneToDate,
        sort: true
      },
      {
        dataField: 'moduser',
        text: 'Utolsó módosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'allapot',
        text: 'Állapot',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: (cell, row, rowIndex, colIndex) => {
          return {
            wordBreak: 'break-all',
            whiteSpace: 'pre-line',
            backgroundColor: '#' + row.szin
          };
        },
        formatter: this.allapotFormatter,
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !this.props.globals.hasRole(['UGYFELSZOLGALAT_ESET'], true) && !this.props.globals.hasRoleSpec(['UGYFELSZOLGALAT_ESET_MOD']),
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        {this.props.globals.hasRole(['UGYFELSZOLGALAT_ESET']) && (
          <ProgressButton
            className="table-new-button btn-cursor-pointer"
            color="success"
            style={{ marginBottom: 10, marginTop: 10 }}
            disabled={this.state.baseJson.length < 1}
            onClick={this.onXlsxClick}
            loading={this.state.xlsxButtonLoading}
          >
            {'Export xlsx'}
          </ProgressButton>
        )}
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  onXlsxClick = () => {
      this.setState({
        xlsxButtonLoading: true
      });
  
      let ids = this.state.baseJson && this.state.baseJson.map(x => x.id);
  
      Services.exportEsetXlsx(ids, (err, res) => {
        if (!err) {
          this.setState({
            xlsxButtonLoading: false
          });
          this.props.globals.addSuccess('Xlsx fájl letöltés indítása...');
          FileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), 'eset_lista_.xlsx');
        } else {
          this.setState({
            xlsxButtonLoading: false
          });
        }
      });
    }

renderForm = () => {
  const {
    formNev,
    formAzonosito,
    formSzinkod,
    formAkadalymentesitett,
    formHasznalhato,
    formType
  } = this.state;

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
          <RFField
            label="Azonosító: *"
            name="formAzonosito"
            maxLength="15"
            disabled={formType === 'MOD'}
            value={formAzonosito}
            onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="col-md-12">
          <RFField
            label="Név: *"
            name="formNev"
            value={formNev}
            onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="col-md-12">
          <RFField
            label="Színkód: *"
            name="formSzinkod"
            value={formSzinkod}
            disabled
            // onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="col-md-12">
          <GithubPicker
            color={formSzinkod}
            onChangeComplete={this.handleColorChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

renderHelyszinOptions = () => {
  return this.state.formHelyszinOptions.map((item) => {
    return (
      <option
        value={item.helyszinid}
        key={item.helyszinid}
      >
        {item.helyszinnev}
      </option>
    );
  });
}

renderTipusOptions = () => {
  return this.state.formTipusOptions.map((item) => {
    return (
      <option
        value={item.id}
        key={item.id}
      >
        {item.nev}
      </option>
    );
  });
}

renderEvhoOptions = () => {
  return this.state.formEvhoOptions.map((item) => {
    return (
      <option
        value={item}
        key={item}
      >
        {Moment(item, 'YYYYMM').format('YYYY. MMMM')}
      </option>
    );
  });
}

render() {
  const {
    withoutFilters,
    formAzonosito,
    formNev,
    formHelyszin,
    formTipus,
    formEvho,
    switchActiveButton
  } = this.state;

  let cardStyle = {
    padding: 20
  };

  return (
    <div>
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            Ügyfélszolgálat esetek
            <CustomTooltip text={getTooltip('esetek')} id="esetekTT" />
            </div>
          <div className="row" style={cardStyle}>
        <div className="col-md-6">
          {this.props.globals.hasRole(['UGYFELSZOLGALAT_ESET'], true) && (
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új eset'}
            </Button>
          )}
        </div>
        <div className="col-md-6 pull-right">
          <SwitchButton
            active={switchActiveButton == 1}
            className="pull-right"
            trueLabel="Folyamatban"
            trueToggle={() => {
              this.setState({
                switchActiveButton: 1
              }, () => {
                this.listBejelentes();
              });
            }}
            trueWidth={120}
            falseToggle={() => {
              this.setState({
                switchActiveButton: 3,
                formHelyszinOptions: [],
                formEvhoOptions: [],
                formTipusOptions: []
              }, () => {
                Services.initBejelentesFiltes((err, res) => {
                  if (!err) {
                    if (res[0].helyszin.length == 1)
                      this.setState({ formHelyszin: res[0].helyszin[0].helyszinid });
                    this.setState({
                      formHelyszinOptions: res[0].helyszin,
                      formEvhoOptions: res[0].evho,
                      formTipusOptions: res[0].tipus
                    });
                  }
                });
              });
            }}
            falseLabel="Előszűrés"
            falseWidth={110}
          />
        </div>
      </div>
      {this.state.switchActiveButton === 3 && (
        <div className="col-md-12">
          <RFForm onSubmit={() => { this.listBejelentes() }}>
            <div className="row">
              <div className="col-md-2">
                <RFField
                  label="Azonosító: "
                  name="formAzonosito"
                  type="number"
                  value={formAzonosito}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="col-md-2">
                <RFField
                  label="Ügyfél neve: "
                  name="formNev"
                  value={formNev}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="col-md-2">
                <RFField
                  label="Helyszín: "
                  type="select"
                  name="formHelyszin"
                  value={formHelyszin}
                  disabled={this.state.formHelyszinOptions.length === 0}
                  onChange={this.handleInputChange}
                  defaultSelect={<option value="">Válassz helyszínt...</option>}
                  selectOptions={this.renderHelyszinOptions()}
                />
              </div>
              <div className="col-md-2">
                <RFField
                  label="Típus: "
                  type="select"
                  name="formTipus"
                  value={formTipus}
                  disabled={this.state.formTipusOptions.length === 0}
                  onChange={this.handleInputChange}
                  defaultSelect={<option value="">Válassz típust...</option>}
                  selectOptions={this.renderTipusOptions()}
                />
              </div>
              <div className="col-md-2">
                <RFField
                  label="Érkezett: "
                  type="select"
                  name="formEvho"
                  value={formEvho}
                  disabled={this.state.formEvhoOptions.length === 0}
                  onChange={this.handleInputChange}
                  defaultSelect={<option value="">Válassz időpontot...</option>}
                  selectOptions={this.renderEvhoOptions()}
                />
              </div>
              <div className="col-md-2">
                <ProgressButton
                  className="table-new-button btn-cursor-pointer"
                  color="success"
                  style={{ marginBottom: 10, marginTop: 29 }}
                  loading={this.state.tableStatus === 'LOAD'}
                >
                  {'Keresés'}
                </ProgressButton>
              </div>
            </div>
          </RFForm>
        </div>
      )}
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          QUERY: (<QueryEmptyState hasImage />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => { this.listBejelentes(); }}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>
      <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="sm">
        <RFForm
          modal
          onSubmit={this.submitForm}
          title={this.renderFormTitle()}
          footer={
            <>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Mégsem</Button>
            </>
          }
        >
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => {}}
            />),
            DATA: (this.renderForm())
          }[this.state.formStatus]}
        </RFForm>
      </Modal>
      <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
        <ModalHeader>Törlés</ModalHeader>
        <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.deleteBejelentes()}
            loading={this.state.deleteButtonLoading}
          >
            {'Igen'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>
    </div>
    </div>
    </div>
  );
}
}

UgyfelszolgalatContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default UgyfelszolgalatContent;
